export default __webpack_public_path__ + "static/media/yc.21f6229c.png";